import { useApiStore } from '@/stores/useApiStore';

export const initApi = async () => {
	const apiStore = useApiStore();

	apiStore.connectAPI();
};
